import(/* webpackMode: "eager" */ "/opt/build/repo/app/(frontend)/(withLayout)/[slug]/loading.tsx");
